// 引入拦截器
import { registerRequestSignInterceptor } from '@patsnap/common-ps-http/dist/RequestSignInterceptor';
import { sign } from '@patsnap/common-ps-http/dist/crypto';
import type { psAxios } from '@patsnap/common-ps-http';
import type { AxiosResponse, AxiosError } from 'axios';

const coreBasicApiUrlPrefix = `${import.meta.env.VITE_CORE_BASIC_SERVICE_URI}/core-basic-api`;

function fetchWithTimeout(url: string, options: any, timeout: number) {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
            reject(new Error('timeout'));
        }, timeout);

        fetch(url, options)
            .then(res => {
                clearTimeout(timer);
                resolve(res);
            })
            .catch(err => {
                clearTimeout(timer);
                reject(err);
            });
    });
}

function applySignInterceptors(axios:typeof psAxios) {
    // 注册拦截器
    const requestSignInterceptor = registerRequestSignInterceptor(
        // axios实例
        axios, {
            // [必填] 决定是否需要拦截错误的请求
            // eslint-disable-next-line
            detectResponseShouldRefresh (response: AxiosResponse | AxiosError) {
                return false;
            },
            // [必填] 获取服务器的时间戳(毫秒),当detectResponseShouldRefresh返回true的时候调用
            getServiceTimeStamp() {
                const now = Date.now();
                return fetchWithTimeout(`${coreBasicApiUrlPrefix}/analytics/security/timestamp?lt=${now}`, {}, 11000)
                    .then((res: any) => res.json())
                    .then(d => parseInt(d.data))
                    .catch(() => Date.now());
            },
            // [可选] 决定是否需要添加请求签名,不传此参数,默认所有接口都会加请求签名头
            detectShouldSignRequest(config, fullUrl) {
                return fullUrl.includes('basic-service.zhihuiya.com') || fullUrl.includes('search-service.zhihuiya.com');
            },
        });
    // 如果你想一开始就同步下服务器时间调用下面的方法,再调用自己的业务请求
    requestSignInterceptor.syncServiceTime();

    requestSignInterceptor.sign = sign;
}

export {
    applySignInterceptors,
};
